import { styled } from "@mui/material/styles";

// Footer root element
export const Root = styled("footer")(() => ({
  position: "sticky",
  bottom: 0,
  top: "100%",
  marginTop: "auto",
}));

// Props type for InnerContainer
interface InnerContainerProps {
  isMobile: boolean;
}

// Inner container with responsive layout
export const InnerContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<InnerContainerProps>(({ theme, isMobile }) => ({
  backgroundColor: theme.palette.common.white,
  height: isMobile ? "unset" : "50px",
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  alignItems: "center",
  justifyContent: "space-between",
}));

// Bold text span
export const TextBold = styled("span")(() => ({
  marginRight: "6px",
  fontWeight: 700,
  fontSize: "14px",
}));

// Red-colored text using theme
export const TextRed = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
}));
